import { render, staticRenderFns } from "./ResendDocuments.vue?vue&type=template&id=34c1337d&"
import script from "./ResendDocuments.vue?vue&type=script&lang=js&"
export * from "./ResendDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports